<template>
  <div class="pl">
    <!-- 导航栏 -->
    <div class="van-nav-bar van-hairline--bottom custom-nav">
    	<div class="van-nav-bar__content">
    		<div class="van-nav-bar__title van-ellipsis">
    			{{$t('common.pingluntitle')}}
    		</div>
    	</div>
    </div>
    
    <!-- 内容区域 -->
    <van-pull-refresh v-model="refreshing" class="fixedStyle" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('common.nomore')"
          @load="onLoad">
		  <van-cell-group class="custom-cell-group">
		    <van-cell 
          v-for="(item,i) in tableList" 
          :key="i" 
          :title="item.title" 
          :value="item.auther" 
          :label="item.content" 
          @click="quickList(item.id)"
          class="custom-cell"
        >
				<template #title>
					<div class="title-container">
						<!-- 本地对话图标 -->
						<div class="icon-wrapper">
              <img 
                src="/img/duihua.png" 
                alt="对话图标" 
                class="logo-img"
                @load="onImageLoad"
                @error="onImageError"
              />
              <!-- 备用SVG图标 -->
              <svg v-if="!logoLoaded" t="1721097804862" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M832 128H192c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h160v128l192-128h288c52.8 0 96-43.2 96-96V224c0-52.8-43.2-96-96-96z" fill="#07C160" fill-opacity="0.1"/>
                <path d="M768 256H256c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h128v64l128-64h256c17.6 0 32-14.4 32-32V288c0-17.6-14.4-32-32-32z" fill="#07C160"/>
                <path d="M384 384h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16zM384 480h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16zM384 576h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16z" fill="#FFFFFF"/>
              </svg>
            </div>
						<!-- 标题和内容 -->
						<div class="content-wrapper">
              <h1 class="title-text">
                {{item.title}}
              </h1>
              <div class="content-text">
                {{item.content}}
              </div>
            </div>
					</div>
				</template>
        <!-- 作者信息 -->
        <template #value>
          <div class="author-info">
            <span class="author-name">{{item.auther}}</span>
            <div class="meta-info">
              <span class="time">2小时前</span>
              <span class="view-btn">查看</span>
            </div>
          </div>
        </template>
			</van-cell>
		  </van-cell-group>
      </van-list>
      <van-empty :description="$t('common.nodata')" v-if="tableList.length === 0" class="custom-empty"/>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data () {
    return {
      page:1,
      isLoading: false, // 用于加载状态
      refreshing: false, // 专门用于下拉刷新状态
      count:0,
	  limit:10,
      loading: false,
      finished: false,
      tableList:[],
      logoLoaded: false,
      scrollTop1: 0,
      // 保存滚动位置
      savedScrollPosition: 0
    }
  },
  mounted () {
    this.getPinglunList()
    // 修复：使用 window 的滚动监听，而不是特定元素
    window.addEventListener("scroll", this.handleScroll);
    
    // 恢复滚动位置（如果有）
    this.restoreScrollPosition();
  },
  beforeDestroy() {
    // 修复：移除 window 的滚动监听
    window.removeEventListener("scroll", this.handleScroll);
    
    // 保存滚动位置
    this.saveScrollPosition();
  },
  activated() {
    // 如果使用 keep-alive，恢复滚动位置
    this.restoreScrollPosition();
  },
  deactivated() {
    // 如果使用 keep-alive，保存滚动位置
    this.saveScrollPosition();
  },
  methods: {
    onImageLoad() {
      this.logoLoaded = true;
    },
    onImageError() {
      this.logoLoaded = false;
      console.log('图片加载失败，使用备用图标');
    },
	
    quickList(id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Login'})
	  }else {
	    this.$router.push({path:'/PinglunDetail?id='+id})
	  }
	},
    
    longPress() {
      // 修复：使用 window 滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    
    // 修复：重写 scrollTops 方法，使用 window 而不是 querySelector
    scrollTops(){
      this.scrollTop1 = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    
    // 新增：处理窗口滚动
    handleScroll() {
      this.scrollTops();
    },
    
    // 保存滚动位置
    saveScrollPosition() {
      this.savedScrollPosition = this.scrollTops();
    },
    
    // 恢复滚动位置
    restoreScrollPosition() {
      if (this.savedScrollPosition > 0) {
        setTimeout(() => {
          window.scrollTo({
            top: this.savedScrollPosition,
            behavior: 'auto'
          });
        }, 100);
      }
    },
    
    getPinglunList(){
        this.$http({
          method: 'get',
          data:{page: this.page,limit: this.limit},
          url: 'sys_pinglun'
        }).then(res=>{
			console.log(res);
          this.tableList  = this.tableList.concat(res.data.data);
          this.count = res.data.total;
          this.page++;      
        })
    },
    
    onRefresh(){
      // 保存当前滚动位置
      this.saveScrollPosition();
      
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.page = 1; // 重置页码
        this.tableList = []; // 清空列表
        
        // 重新加载数据
        this.$http({
          method: 'get',
          data:{page: this.page,limit: this.limit},
          url: 'sys_pinglun'
        }).then(res=>{
          console.log('刷新数据:', res);
          this.tableList = res.data.data || [];
          this.count = res.data.total;
          this.page++;
          
          // 恢复滚动位置
          this.restoreScrollPosition();
        }).catch(error => {
          console.error('刷新失败:', error);
        }).finally(() => {
          this.refreshing = false;
          this.loading = false;
          Toast(this.$t('common.refresh'));
        });
      }, 500);
    },
    
    onLoad() {
      // 保存当前滚动位置
      this.saveScrollPosition();
      
      // 加载更多数据
      this.getPinglunList();
      
	  let timer = setTimeout(() => {
	    this.loading = false;
	    
	    // 检查是否已加载所有数据
	    if (this.tableList.length >= this.count) {
	      this.finished = true;
	    }
	    
	    // 恢复滚动位置
	    this.restoreScrollPosition();
	    
	    this.finished && clearTimeout(timer);//清除计时器
	  }, 500);
    },
  },
}
</script>

<style lang='less' scoped>
// 渐变背景色
@gradient-start: #667eea;
@gradient-end: #764ba2;
@wechat-green: #07C160;

.pl {
  padding-bottom: 3.33333rem;
  background: linear-gradient(135deg, #f8f9fa, #f0f2f5);
  min-height: 100vh;
}

// 导航栏样式
.custom-nav {
  height: 3rem;
  line-height: 3rem;
  background: linear-gradient(135deg, @gradient-start, @gradient-end) !important;
  color: white;
  
  .van-nav-bar__title {
    color: white;
    font-weight: 600;
  }
}

// 单元格组样式
.custom-cell-group {
  background: transparent;
  margin: 0.5rem;
  padding: 0.5rem 0;
}

// 单元格样式 - 统一尺寸和发光边框
.custom-cell {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: calc(100% - 1rem);
  margin: 0.75rem auto;
  padding: 1.25rem 1rem;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background: #fff;
  border-radius: 16px;
  border: 2px solid transparent;
  box-shadow: 
    0 4px 16px rgba(102, 126, 234, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.9),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  min-height: 120px;
  align-items: flex-start;
  
  // 发光边框效果
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, @gradient-start, @gradient-end, @wechat-green);
    border-radius: 18px;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    background: linear-gradient(135deg, 
      rgba(102, 126, 234, 0.03), 
      rgba(118, 75, 162, 0.03),
      rgba(7, 193, 96, 0.02));
    z-index: -1;
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 
      0 8px 32px rgba(102, 126, 234, 0.25),
      0 0 0 1px rgba(255, 255, 255, 0.95),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    
    &::before {
      opacity: 1;
    }
  }
}

// 标题容器
.title-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex: 1;
}

// 图标包装
.icon-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, rgba(7, 193, 96, 0.1), rgba(102, 126, 234, 0.1));
  border-radius: 14px;
  margin-right: 1.25rem;
  border: 2px solid rgba(7, 193, 96, 0.2);
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  .logo-img {
    width: 28px;
    height: 28px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
  
  .icon {
    width: 28px;
    height: 28px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
  
  .custom-cell:hover & {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.25);
    border-color: rgba(7, 193, 96, 0.3);
  }
}

// 内容包装
.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 70px;
  justify-content: space-between;
  padding-right: 1rem;
}

// 标题文本
.title-text {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.75rem 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.2px;
}

// 内容文本
.content-text {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

// 作者信息
.author-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
  min-width: 90px;
  margin-left: auto;
}

.author-name {
  color: #555;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
}

.meta-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.time {
  color: #999;
  font-size: 0.75rem;
  white-space: nowrap;
}

.view-btn {
  background: linear-gradient(135deg, @wechat-green, @gradient-end);
  color: #fff;
  font-size: 0.8rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.3);
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  }
}

// 移除原有的标签样式
.pl .van-cell__label {
  display: none;
}

// 空状态样式
.custom-empty {
  margin-top: 3rem;
  
  .van-empty__description {
    color: #999;
    font-size: 1rem;
  }
}

// 下拉刷新区域
.fixedStyle {
  background: transparent;
}

// 响应式调整
@media (max-width: 768px) {
  .custom-cell {
    padding: 1rem 0.8rem;
    margin: 0.6rem auto;
    min-height: 110px;
    border-radius: 14px;
  }
  
  .title-text {
    font-size: 0.95rem;
  }
  
  .content-text {
    font-size: 0.85rem;
    -webkit-line-clamp: 2;
  }
  
  .icon-wrapper {
    width: 46px;
    height: 46px;
    margin-right: 1rem;
    border-radius: 12px;
    
    .logo-img,
    .icon {
      width: 24px;
      height: 24px;
    }
  }
  
  .author-info {
    min-width: 80px;
  }
  
  .view-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
  }
}

// 确保所有单元格高度一致
.van-cell-group .van-cell {
  min-height: 120px;
  display: flex;
  align-items: flex-start;
}

// 列表项统一高度
.van-list .van-cell {
  min-height: 120px !important;
}

// 加载更多文本样式
.van-list__finished-text {
  color: #999;
  font-size: 0.9rem;
  padding: 2rem 0;
}
</style>


